import { useQuery } from '@tanstack/react-query';

import { seedService } from 'services';

export const seedKeys = {
  all: [{ scope: 'seed' }] as const,
  lists: () => [{ ...seedKeys.all[0], entity: 'list' }] as const,
  list: () => [{ ...seedKeys.lists()[0] }] as const,
};

const seedValueSet = async () => seedService.seedValueSet();

export const useSeed = () =>
  useQuery({ queryKey: seedKeys.list(), queryFn: seedValueSet, enabled: false });
